import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { DatasourceService } from '@app/core/services';
import { State } from '@progress/kendo-data-query';
import { ExcelExportComponent, WorkbookOptions } from '@progress/kendo-angular-excel-export';


@Component({
  selector: 'services-inventory-report',
  template: `
    <kendo-excelexport [filterable]="true">
      <kendo-excelexport-column field="x" title="#" width="50"></kendo-excelexport-column>      
      <kendo-excelexport-column field="service_status_name" title="Estatus" width="130"></kendo-excelexport-column>
      <kendo-excelexport-column field="output_date" title="Fecha y hora de salida" width="180"></kendo-excelexport-column>      
      <kendo-excelexport-column field="entry_date" title="Fecha y hora de entrada" width="180"></kendo-excelexport-column>      
      <kendo-excelexport-column field="crane_name" title="Grúa" width="200"></kendo-excelexport-column>
      <kendo-excelexport-column field="person_operator_name" title="Operador" width="300"></kendo-excelexport-column>
      <kendo-excelexport-column field="place" title="Destino" width="300"></kendo-excelexport-column>
      <kendo-excelexport-column field="cost" title="Costo" width="120" [cellOptions]="{ format: '$#,##0.00' }">
        <ng-template kendoExcelExportFooterTemplate>
          
        </ng-template>
      </kendo-excelexport-column>
      <kendo-excelexport-column field="payment_type_name" title="Tipo de pago" width="150"></kendo-excelexport-column>
      <kendo-excelexport-column field="customer_name" title="Cliente" width="300"></kendo-excelexport-column>
      <kendo-excelexport-column field="credit_days" title="Días de crédito" width="100"></kendo-excelexport-column>
      <kendo-excelexport-column field="expiration_date" title="Fecha de vencimiento" width="180"></kendo-excelexport-column>
      <kendo-excelexport-column field="invoice" title="Núm de factura" width="150"></kendo-excelexport-column>
      <kendo-excelexport-column field="observations" title="Observaciones" width="250"></kendo-excelexport-column>
    </kendo-excelexport>`,
  styles: [``],
})
export class ServicesReportComponent implements OnInit {

  //ExcelExport
  @ViewChild(ExcelExportComponent, {static: false}) report !: ExcelExportComponent;

  public name: string = 'report';

  protected table: string = 'services_inventories';  

  constructor(protected service : DatasourceService) { 

  }

  public downloadByStatus(id_service_status: number = 0) {

    let state : State = {
      skip: 0, 
      take: 0, 
      sort: [{field: 'output_date', dir: 'desc'}], 
      filter: {
        logic: "and",
        filters: []
      }, 
      group: []
    }

    if(id_service_status != 0){
      state.filter.filters.push({
          field: 'id_service_status',
          operator: 'eq',
          value: id_service_status
      })
    }

    this.readData(state);

  }

  public downloadByRange(range: any) {

    let state : State = {
      skip: 0, 
      take: 0, 
      sort: [{field: 'output_date', dir: 'desc'}], 
      filter: {
        logic: "or",
        filters: [
          {
            field: 'output_date',
            operator: 'inrange',
            value: `${range.start} 00:00:00,${range.end} 23:59:59`
          },
          {
            field: 'entry_date',
            operator: 'inrange',
            value: `${range.start} 00:00:00,${range.end} 23:59:59`
          }
        ]
      }, 
      group: []
    }

    this.readData(state);

  }

  protected readData(state: State) {    

    this.service.get(this.table, state)
      .subscribe(
        (res) => {
          console.log("RESPONSE: ", res);
          this.report.fileName = `${this.name}.xlsx`;
          this.report.data = res.data; 
          let options: WorkbookOptions = this.applyFormat(this.report);
          this.report.save(options);

        },
        (fail) => {        
          console.log("Error", fail);
        }
      ); 

  }

  protected applyFormat(report: ExcelExportComponent): WorkbookOptions {

    const options = report.workbookOptions();
    const rows = options.sheets[0].rows;
    const columns = rows[0].cells;
    // console.log(rows, columns);
    
    let index: number = 0;
    let total: number = 0;
    rows.forEach((row) => {
      if (row.type === "data") {
        index++;        
        row.cells.forEach((cell, i) => {
          if(typeof columns[i].value != 'undefined'){
            switch(columns[i].value){ 
              case '#': {
                cell.value = index;
              }; break;             
              case 'Estatus': {
                cell.background = '#' + report.data[index-1].service_status_color;
                cell.color = '#ffffff';
              }; break;
              case 'Costo': {
                cell.format = "$#,##0.00";
                total= total + ((cell.value != null) ? parseFloat(<any>cell.value): 0);  
              }; break; 
            }
          }
        });
      } 
      else if (row.type === "footer") {
        row.cells.forEach((cell, i) => {
          if(typeof columns[i].value != 'undefined'){
            switch(columns[i].value){ 
              case 'Costo': {
                cell.value = total;
                cell.format = "$#,##0.00";
              }; break;
            }
          }
        });
      }
    });

    return options;

  }

  ngOnInit() {

  }

}
